/**
 * The tenant's rate-card faces, loaded once per Strategies page
 * (CU-869fh646w, plan § 4.4).
 *
 * The "Rate cards that fit" block of the wizard, the red line of the
 * footer and the "Rate cards" column of the table all need the same
 * list — `GET /setup/rate-cards/faces`, the call the Activity already
 * makes — and the fit is a pure function over it and the form
 * (`@services/rateCardsFit`). Loaded here, next to the axis catalogue,
 * so the page asks once and not per open.
 *
 * Three states, kept apart on purpose: `loading` and `failed` are "I do
 * not know", which is not "none" — the block paints amber for the
 * first and red for the second, and the table reads `—` rather than
 * `none` (UX D4, D6). A list that could not be read never blocks a save.
 */
import React, { createContext, useContext, useEffect, useState } from 'react'
import { setupApi } from 'Pages/DsRepricing/Setup/@services/api'

const RateCardFaces = createContext({ faces: [], loading: true, failed: false })

export function RateCardFacesProvider({ children }) {
	const [state, setState] = useState({ faces: [], loading: true, failed: false })
	useEffect(() => {
		let alive = true
		setupApi.faces.list()
			.then(faces => { if (alive) setState({ faces: Array.isArray(faces) ? faces : [], loading: false, failed: false }) })
			.catch(() => { if (alive) setState({ faces: [], loading: false, failed: true }) })
		return () => { alive = false }
	}, [])
	return <RateCardFaces.Provider value={state}>{children}</RateCardFaces.Provider>
}

export function useRateCardFaces() {
	return useContext(RateCardFaces)
}
